import React from "react";
import { useAppDispatch } from "src/store/store";
import { Field, useFormikContext } from "formik";
import { StyledTextField } from "./styled-components/AddressFields";
import { StyledEndAdorment } from "./AddressLookup";
import { Label } from "./SelectAccountType";
import { setSSN, setUserDoesNotHoldSSN, useOnboarding } from "src/store/features/onboarding.slice";
import { FormValues } from "./utils/formSchema";
import { useEffect } from "react";
import { Checkbox, Stack } from "@mui/material";

export const SocialSecurityField = () => {
  const dispatch = useAppDispatch();
  const [checked, setChecked] = React.useState(false);
  const { setErrors } = useFormikContext();

  const {
    nationality,
    address: { country },
  } = useOnboarding();

  const {
    values: { ssn },
    errors: { ssn: ssnError },
    setFieldValue,
  } = useFormikContext<FormValues>();

  const isPartialAmerican = () => {
    return country === "United States" || nationality === "American";
  };

  const isAmericanAndResident = () => {
    return country === "United States" && nationality === "American";
  };

  useEffect(() => {
    dispatch(setSSN(ssn));
  }, [ssn]);

  const handleSSNChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    // Remove all non-digits
    const sanitizedValue = value.replace(/\D/g, "");
    setFieldValue("ssn", sanitizedValue);
  };

  const handleChange = (e: React.SyntheticEvent<Element, Event>, value: boolean) => {
    setChecked(value);
    dispatch(setUserDoesNotHoldSSN(value));
  };

  useEffect(() => {
    setChecked(false);
    dispatch(setUserDoesNotHoldSSN(false));
    setErrors({ ssn: "" });
  }, [country, nationality]);

  useEffect(() => {
    setErrors({ ssn: "" });
  }, [checked]);

  return (
    <>
      {isPartialAmerican() ? (
        <>
          {!isAmericanAndResident() ? (
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Label text="Social Security Number (SSN)" />
              <Stack direction="row" alignItems="center" mr={1}>
                <Checkbox defaultChecked={checked} onChange={handleChange} name={"ssnCheckBox"} />
                <Label text="I do not hold a valid SSN" />
              </Stack>
            </Stack>
          ) : (
            <Label text="Social Security Number (SSN)" />
          )}
          <Field
            data-testid="ssn-input-field"
            name="ssn"
            as={StyledTextField}
            type={"text"}
            selected={ssn?.length > 8}
            error={!!ssnError}
            helperText={ssnError}
            onChange={handleSSNChange}
            disabled={checked}
            sx={{
              backgroundColor: checked ? "var(--primary-grey-100-p, #F5F5F5)" : "white",
              borderRadius: "16px",
            }}
            InputProps={{
              endAdornment: <StyledEndAdorment selected={ssn?.length > 8} />,
              inputProps: { maxLength: 11 },
            }}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
};
